var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 78,
    viewBox: "0 0 64 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 78C36.4 78 40 74.4 40 70H24C24 74.4 27.56 78 32 78ZM56 54V34C56 21.72 49.44 11.44 38 8.72V6C38 2.68 35.32 0 32 0C28.68 0 26 2.68 26 6V8.72C14.52 11.44 8 21.68 8 34V54L0 62V66H64V62L56 54Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.e8251da3f7bb07e7ea963897d327a813.svg";
export { ForwardRef as ReactComponent };